import React from 'react';
import MuiTooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core';
import Colors from '../internal-components/Colors';

const Tooltip = withStyles(theme => ({
  // arrow: {
  //   marginLeft: '18px !important'
  // },
  tooltip: {
    color: '#fff',
    borderRadius: 8,
    '& svg': { color: '#fff' }
  }
}))(MuiTooltip);

const TransparentTooltip = withStyles(theme => ({
  // arrow: {
  //   marginLeft: '18px !important'
  // },
  tooltip: {
    color: '#fff',
    borderRadius: 8,
    background: 'rgba(0, 0, 0, 0)',
    margin: 0
    // '& svg': { color: '#fff' }
  }
}))(MuiTooltip);

const WhiteTooltip = withStyles(theme => ({
  arrow: {
    color: '#fff'
  },
  tooltip: {
    color: '#000',
    borderRadius: 8,
    background: '#fff',
    boxShadow: `2px 2px 5px 0px ${Colors.BORDER_GREY}`
    // '& svg': { color: '#fff' }
  }
}))(MuiTooltip);

const ActionsTooltip = ({ buttons = [], children, variant, ...props }) => {
  if (variant === 'transparent') {
    return (
      <TransparentTooltip
        interactive
        placement="right"
        leaveDelay={500}
        title={buttons}
        {...props}
      >
        {children}
      </TransparentTooltip>
    );
  }
  if (variant === 'white') {
    return (
      <WhiteTooltip
        interactive
        placement="right"
        leaveDelay={500}
        title={buttons}
        {...props}
      >
        {children}
      </WhiteTooltip>
    );
  }

  return (
    <Tooltip
      arrow
      interactive
      placement="right"
      leaveDelay={500}
      title={buttons}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default ActionsTooltip;
